// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('orderHeadChoice', {
//         templateUrl: 'views/components/views/orderHeadChoice/orderHeadChoice.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'translateService', 'stateService', 'modalService', 'orderHeadChoiceService', function ($stateParams, translateService, stateService, modalService, orderHeadChoiceService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let orderHeadChoiceKeyno = $stateParams.orderheadchoice_keyno;

//             let translations = {
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 edit: {},
//                 selectListRelatedChoices: [],
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATE SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATE SERVICE

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await orderHeadChoiceService.getEdit({ orderheadchoice_keyno: orderHeadChoiceKeyno }))[0];
//             }

//             async function loadRelatedChoices() {
//                 return vm.model.selectListRelatedChoices = await orderHeadChoiceService.listRelatedChoices(vm.model.edit);
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 orderHeadChoiceService.saveObj(vm.model.edit).then((response) => {
//                     if (response[0] && response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: (dialogItself) => {
//                     				dialogItself.close();
//                     				vm.model.lockedSave = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedSave = false;
//                     	stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadRelatedChoices();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
